import api from '.';
import { GenerateChatTokenResponse } from '@karehero/models';

export const chatApi = api.injectEndpoints({
  endpoints: (builder) => ({
    generateChatToken: builder.mutation<GenerateChatTokenResponse, void>({
      query: () => ({
        url: `/chat-token`,
        method: 'POST',
      }),
    }),
  }),
});

export const { useGenerateChatTokenMutation } = chatApi;

export default chatApi;
